import React, { Component, PropTypes } from 'react';

class PagesGuestPayment extends Component {
    render() {
        return <div>{this.props.children}</div>;
    }
}

PagesGuestPayment.propTypes = {
    children: PropTypes.element
};

export default PagesGuestPayment;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesGuestPayment.js